import styled from "styled-components";

export const Body = styled.div`
  padding: 4px 18px 8px;
  overflow-y: auto;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const SelectLabel = styled.div`
  font-size: 12.5px;
  font-weight: 700;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-bottom: 6px;
`;

export const SelectHint = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 6px;
`;

export const Footer = styled.div`
  display: flex;
  gap: 11px;
  padding: 12px 18px calc(16px + env(safe-area-inset-bottom));
`;
